import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M0 0v7.247C0 12.927 3.803 16.5 9 18c5.198-1.5 9-6.289 9-11.969V0H0zm7.344 11.608L4.034 8.3l1.061-1.061 2.249 2.248 5.562-5.561 1.061 1.061-6.623 6.621z" />
  </svg>
);

export default SvgComponent;
